export default __webpack_public_path__ + "static/media/InvertedCommas.1abc73f3.svg";